import $ from 'jquery'

const $contactDetailForm = $('#contact-detail-form')

function setRequiredFieldsByRequestInterest (requiredFields) {
  requiredFields.forEach(function (field) {
    $contactDetailForm
      .find('#' + field)
      .siblings('span.placeholder')
      .find('span.placeholder-text')
      .addClass('css-required')
  })
}

function resetRequiredFieldsByRequestInterest () {
  $('span.placeholder-text').removeClass('css-required')
}

export default {
  setRequiredFieldsByRequestInterest,
  resetRequiredFieldsByRequestInterest
}
